import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../seo/Seo';
import NotFoundContent from '../seo/content/NotFoundContent';

const RouterLink = ({ href, className, children }) => (
  <Link to={href} className={className}>
    {children}
  </Link>
);

const NotFound = () => (
  <>
    <Seo
      title="Page not found | Riverside Transfers"
      description="This page could not be found. Browse shuttle tickets, private transfers, route pages, and travel guides on Riverside Transfers."
      path="/"
      noindex
    />
    <NotFoundContent LinkComponent={RouterLink} />
  </>
);

export default NotFound;
